import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

const AdminEditProd = ({ el }) => {
  const [name, setName] = useState(el.name);
  const [imgURL1, setImgURL1] = useState(el.imgURL1);
  const [imgURL2, setImgURL2] = useState(el.imgURL2);
  const [imgURL3, setImgURL3] = useState(el.imgURL3);

  const [price, setPrice] = useState(el.price);
  const [discount, setDiscount] = useState(el.discount);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleedit = (e) => {
    e.preventDefault();
    const newedit = {
      id: Math.random(),
      name: name,
      imgURL: [
        { id: Math.random(), URL: imgURL1 },
        { id: Math.random(), URL: imgURL2 },
        { id: Math.random(), URL: imgURL3 },
      ],
      price: price,
      discount: discount,
    };

    handleClose();
  };
  return (
    <div>
      <Button variant="primary" onClick={handleShow}>
        Edit
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit todo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "25px",
              flexWrap: "wrap",
            }}
            onSubmit={handleedit}
          >
            <Form.Control
              type="text"
              placeholder="Enter your Name"
              style={{ width: "80%" }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Form.Control
              type="text"
              placeholder="imgURL"
              style={{ width: "80%" }}
              value={imgURL1}
              onChange={(e) => setImgURL1(e.target.value)}
            />
            <Form.Control
              type="text"
              placeholder="imgURL"
              style={{ width: "80%" }}
              value={imgURL2}
              onChange={(e) => setImgURL2(e.target.value)}
            />{" "}
            <Form.Control
              type="texte"
              placeholder="imgURL"
              style={{ width: "80%" }}
              value={imgURL3}
              onChange={(e) => setImgURL3(e.target.value)}
            />{" "}
            <Form.Control
              type="number"
              placeholder="Enter your title"
              style={{ width: "80%" }}
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <Form.Control
              type="number"
              placeholder="Enter your discount"
              style={{ width: "80%" }}
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
            />
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminEditProd;
